import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/account/settings/_layout/general')({
  component: () => <div className='flex flex-col items-center'>

    

  </div>
});
